import Login from "./Login";
import LostPassword from "./LostPassword";
import React, { useEffect, useRef, useState } from "react";
import Register from "./Register";
import logo from "../assets/TWB.svg";
import usernotsign from "../assets/user-2.jpg";
import usersignin from "../assets/usersignin.png";
import { DiGoogleAnalytics } from "react-icons/di";
import { FaRegUser } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaBars, FaRegBookmark, FaXmark } from "react-icons/fa6";
import { FiUserPlus } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { IoTriangleSharp } from "react-icons/io5";
import { IoPrintOutline } from "react-icons/io5";
import { MdLogin } from "react-icons/md";
import { MdDisplaySettings } from "react-icons/md";
import { PiFunnelBold, PiSignOutBold } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { remove } from "../redux/userSlice";
import { navItems } from "./navItems";
import { IoAlertCircleSharp } from "react-icons/io5";
import { IoLogoFirebase } from "react-icons/io5";
import { IoCashOutline } from "react-icons/io5";
import { GrTransaction } from "react-icons/gr";
import { MdJoinInner } from "react-icons/md";
import { TbTableExport } from "react-icons/tb";
import { FaUserPlus } from "react-icons/fa6";
import { MdOutlineShoppingCartCheckout } from "react-icons/md";
import { MdCorporateFare } from "react-icons/md";
import { AiFillControl } from "react-icons/ai";
import { VscServerProcess } from "react-icons/vsc";
import { GiWoodPile } from "react-icons/gi";
import { LuCalculator } from "react-icons/lu";
import { RiFileHistoryLine } from "react-icons/ri";
import { TbListDetails } from "react-icons/tb";
import { MdPendingActions } from "react-icons/md";
import { MdOutlineToday } from "react-icons/md";
import config from '../config';
import axios from "axios";
import NotificationBell from "./Notifications/NotificationBell";

const Navbar = () => {

    let menuRef = useRef();
    let reportRef = useRef();
    let adminRef = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const name = useSelector((state) => state.user.name);
    const companyName = useSelector((state) => state.user.companyName);
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
    const [loginModel, setLoginModel] = useState(false)
    const [registerModel, setRegisterModel] = useState(false)
    const [lostpasswordModel, setlostpasswordModel] = useState(false)
    const [isReportOpen, setIsReportOpen] = useState(false)
    const [isMasterOpen, setIsMasterOpen] = useState(false)
    const [isAdminOpen, setIsAdminOpen] = useState(false)
    const [allowedMenuList, setAllowedMenuList] = useState([])
    const [activeParentMenu, setActiveParentMenu] = useState('')
    const [activeSubMenu, setActiveSubMenu] = useState('')

    const [user, setUser] = useState(false)
    const role = useSelector((state) => state.user.role);

    const reportsLinks = [
        { name: "Pending Actions", route: "/pendingactions", icon: <MdPendingActions className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "Traded Report", route: "/traded", icon: <IoAlertCircleSharp className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "Trade Details", route: "/tradeDetails", icon: <TbListDetails className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "Internal Message Log", route: "/internalMessageLog", icon: <IoLogoFirebase className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "Analytics", route: "/analytics", icon: <DiGoogleAnalytics className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "Subscribers", route: "/BasketSubscriberReport", icon: <FaUsers className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "As-On Holding", route: "/AsOnHoldingReport", icon: <MdOutlineToday className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "Allocation Calculator", route: "/AllocationCalculator", icon: <LuCalculator className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "Allocation History", route: "/AllocationHistory", icon: <RiFileHistoryLine className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "Cash Ledger", route: "/CashLedgerReport", icon: <IoCashOutline className="mr-2 text-[16px] cursor-pointer" /> },
        { name: "System Charges", route: "/SystemChargesReport", icon: <IoCashOutline className="mr-2 text-[16px] cursor-pointer" /> },
    ];

    const backOfficeLinks = [
        { route: "/stockedit", icon: <FiEdit className="mr-2 text-[16px] cursor-pointer" />, label: "Stock Edit" },
        { route: "/cashRegister", icon: <IoCashOutline className="mr-2 text-[16px] cursor-pointer" />, label: "Cash Register" },
        { route: "/corporateActions", icon: <MdCorporateFare size={20} className="mr-2 text-[16px] cursor-pointer" />, label: "Corporate Actions" },
        { route: "/clientList", icon: <FaUserPlus className="mr-2 text-[16px] cursor-pointer" />, label: "Add New Client" },
        { route: "/basketSubscription", icon: <MdJoinInner className="mr-2 text-[16px] cursor-pointer" />, label: "Basket Subscription" },
        { route: "/orders", icon: <TbTableExport className="mr-2 text-[16px] cursor-pointer" />, label: "Export Client Orders" },
        { route: "/generateClientOrders", icon: <MdOutlineShoppingCartCheckout size={20} className="mr-2 text-[16px] cursor-pointer" />, label: "Generate Client Orders" },
        { route: "/orderManagement", icon: <TbTableExport className="mr-2 text-[16px] cursor-pointer" />, label: "Order Management" },
        { route: "/ControlPanel", icon: <AiFillControl size={20} className="mr-2 text-[16px] cursor-pointer" />, label: "Control Panel" },
        { route: "/eodProcess", icon: <VscServerProcess className="mr-2 text-[16px] cursor-pointer" />, label: "EOD EOM Process" },
        { route: "/clientHoldingImport", icon: <GiWoodPile size={20} className="mr-2 text-[16px] cursor-pointer" />, label: "Client Holding Import" },
        { route: "/ImportTrades", icon: <GrTransaction className="mr-2 text-[16px] cursor-pointer" />, label: "Import Trades" },
        { route: "/ImportIndexData", icon: <GrTransaction className="mr-2 text-[16px] cursor-pointer" />, label: "Import Index Data" }
    ];
    const adminLinks = [
        { route: "/screens", icon: <IoAlertCircleSharp className="mr-2 text-[16px]" />, label: "Screen" },
        { route: "/screenActions", icon: <MdPendingActions className="mr-2 text-[16px]" />, label: "Screen Actions" },
        { route: "/roles", icon: <TbListDetails className="mr-2 text-[16px]" />, label: "Roles" },
        { route: "/menuScreenActionMapping", icon: <IoLogoFirebase className="mr-2 text-[16px]" />, label: "Menu Screen Action Mapping" },
        { route: "/roleMenuMapping", icon: <IoLogoFirebase className="mr-2 text-[16px]" />, label: "Role Menu Mapping" },
        { route: "/userRoleMapping", icon: <IoLogoFirebase className="mr-2 text-[16px]" />, label: "User Role Mapping" },
        { route: "/screenActionRoleMapping", icon: <IoLogoFirebase className="mr-2 text-[16px]" />, label: "ScreenAction Role Mapping" },
        
    ];

    // Track active menu based on current route
    useEffect(() => {
        const currentPath = location.pathname;
        
        // Check if current route is in backOfficeLinks
        const backOfficeItem = backOfficeLinks.find(item => item.route === currentPath);
        if (backOfficeItem) {
            setActiveParentMenu('backoffice');
            setActiveSubMenu(backOfficeItem.label);
            return;
        }

        // Check if current route is in reportsLinks
        const reportItem = reportsLinks.find(item => item.route === currentPath);
        if (reportItem) {
            setActiveParentMenu('report');
            setActiveSubMenu(reportItem.name);
            return;
        }

        // Check if current route is in adminLinks
        const adminItem = adminLinks.find(item => item.route === currentPath);
        if (adminItem) {
            setActiveParentMenu('admin');
            setActiveSubMenu(adminItem.label);
            return;
        }

        // Reset if not in any submenu
        setActiveParentMenu('');
        setActiveSubMenu('');
    }, [location.pathname]);

    // out side menu click - menu hide
    useEffect(() => {
        if (name === null || name === "" || name === undefined) {
            setAllowedMenuList([])
            navigate("/")
        }

        let handle = (e) => {
            // console.log("Click!")
            if (menuRef != null && menuRef.current != null && !menuRef.current.contains(e.target)) {
                closeMenu()
            }
            if (reportRef != null && reportRef.current != null && !reportRef.current.contains(e.target)) {
                closeMenu()
            }
        }
        document.addEventListener("click", handle, true)
        getRoleSpecificMenu(role);

        // Handle window resize to close mobile menu when expanding to desktop
        const handleResize = () => {
            if (window.innerWidth >= 768 && isMenuOpen) {
                // Close mobile menu when resizing to desktop view
                setIsMenuOpen(false)
                setIsReportOpen(false)
                setIsMasterOpen(false)
                setIsAdminOpen(false)
            }
        }
        
        window.addEventListener('resize', handleResize)
        
        return () => {
            window.removeEventListener('resize', handleResize)
        }

    }, [role, isMenuOpen])

    const closeMenu = () => {
        setIsUserMenuOpen(false)
        setIsMenuOpen(false)
        setIsReportOpen(false)
        setIsMasterOpen(false)
        setIsAdminOpen(false)
    }

    const closeMobileMenu = () => {
        setIsMenuOpen(false)
        setIsReportOpen(false)
        setIsMasterOpen(false)
        setIsAdminOpen(false)
    }

    const toggleMenu = () => {
        if (isMenuOpen) {
            // Closing mobile menu - reset all submenu states
            setIsMenuOpen(false)
            setIsReportOpen(false)
            setIsMasterOpen(false)
            setIsAdminOpen(false)
        } else {
            // Opening mobile menu - expand all submenus
            setIsMenuOpen(true)
            setIsReportOpen(true)
            setIsMasterOpen(true)
            setIsAdminOpen(true)
        }
    }

    const toggleUserMenu = async () => {
        setIsUserMenuOpen(!isUserMenuOpen)
    }

    const toggleMasterMenu = () => {
        setIsMasterOpen(!isMasterOpen)
    }

    const toggleReportMenu = () => {
        setIsReportOpen(!isReportOpen)
    }

    const toggleAdminMenu = () => {
        setIsAdminOpen(!isAdminOpen)
    }

    const toggleLoginModal = () => {
        setIsUserMenuOpen(false)
        setIsMenuOpen(false)
        setLoginModel(!loginModel)
        setRegisterModel(false)
        setlostpasswordModel(false)
    }

    const toggleRegisterModal = () => {
        setIsUserMenuOpen(false)
        setIsMenuOpen(false)
        setRegisterModel(!registerModel)
        setLoginModel(false)
        setlostpasswordModel(false)
    }

    const toggleLostPasswordModal = () => {
        setIsUserMenuOpen(false)
        setIsMenuOpen(false)
        setRegisterModel(false)
        setLoginModel(false)
        setlostpasswordModel(!lostpasswordModel)
    }

    const logOut = () => {
        setIsUserMenuOpen(false)
        setIsMenuOpen(false)
        localStorage.removeItem("user")
        dispatch(remove());
        console.log("logout")
        navigate("/")
    }

    const getRoleSpecificMenu = async (roleId) => {
        try {
            const res = await axios.get(config.BL_API_URL + "/MenuRoleMap/v1/getMenuByUserRole", { params: { roleId } });
            if (res.data) {

                setAllowedMenuList(res.data);
            }
            else {
                //setErr("backend error")
            }
        } catch (err) {
/*             if (err.response)
                //setErr(err.response.data);
            else
                //setErr("Server error...");
 */        }
    }

    // const closeMenu = (menulink) => {
    //     setIsUserMenuOpen(false)
    //     setIsMenuOpen(false)
    // }

    const isMenuAllowed = (menu, allowedMenuList) => {
        return allowedMenuList.some(allowedMenu => allowedMenu.toLowerCase() === menu.toLowerCase());
    };

    return (
        <>
            <nav className="bg-gradient-to-b from-gray-50 to-white md:px-14 p-2 max-w-screen-2xl border-b mx-auto text-primary fixed top-0 right-0 left-0 shadow-sm">
                <div className="text-lg container mx-auto flex justify-between items-center font-medium">
                    {/* Logo */}
                    <div className="flex space-x-14 items-center">
                        <Link to="/" className="text-xl font-semibold flex items-center space-x-3 text-primary">
                            <img src={logo} alt="" className="w-10 inline-block items-center cursor-pointer rounded-lg rounded-br-[10px]" />
                        </Link>
                    </div>
                    {name &&
                        <div className="flex space-x-14 items-center">
                            {/* Tab-style Navigation Path Indicator */}
                            {activeParentMenu && activeSubMenu ? (
                                <div className="relative">
                                    {/* Tab container with tab-like appearance for submenu pages */}
                                    <div className="bg-white border-t-2 border-l-2 border-r-2 border-blue-600 rounded-t-lg px-6 py-3 shadow-lg relative">
                                        {/* Tab content */}
                                        <div className="flex items-center space-x-3">
                                            <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
                                                {activeParentMenu}
                                            </span>
                                            <div className="w-1 h-1 bg-blue-400 rounded-full"></div>
                                            <span className="text-gray-700 font-medium text-sm">
                                                {activeSubMenu}
                                            </span>
                                        </div>
                                        
                                        {/* Tab bottom border extension to connect with page */}
                                        <div className="absolute -bottom-px left-0 right-0 h-px bg-white z-10"></div>
                                        
                                        {/* Tab side shadows for depth */}
                                        <div className="absolute -left-1 top-2 bottom-0 w-1 bg-gradient-to-b from-transparent via-gray-200 to-transparent opacity-50"></div>
                                        <div className="absolute -right-1 top-2 bottom-0 w-1 bg-gradient-to-b from-transparent via-gray-200 to-transparent opacity-50"></div>
                                    </div>
                                    
                                    {/* Tab connecting line to navbar bottom */}
                                    <div className="absolute -bottom-1 left-0 right-0 h-1 bg-blue-600 rounded-t-sm"></div>
                                </div>
                            ) : (location.pathname === '/dashboard' || location.pathname === '/') && (
                                <div className="relative">
                                    {/* Simple tab for single-level pages like Dashboard/Home */}
                                    <div className="bg-white border-t-2 border-l-2 border-r-2 border-blue-600 rounded-t-lg px-6 py-3 shadow-lg relative">
                                        <div className="flex items-center">
                                            <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
                                                {location.pathname === '/dashboard' ? 'Dashboard' : 'Home'}
                                            </span>
                                        </div>
                                        
                                        {/* Tab bottom border extension to connect with page */}
                                        <div className="absolute -bottom-px left-0 right-0 h-px bg-white z-10"></div>
                                        
                                        {/* Tab side shadows for depth */}
                                        <div className="absolute -left-1 top-2 bottom-0 w-1 bg-gradient-to-b from-transparent via-gray-200 to-transparent opacity-50"></div>
                                        <div className="absolute -right-1 top-2 bottom-0 w-1 bg-gradient-to-b from-transparent via-gray-200 to-transparent opacity-50"></div>
                                    </div>
                                    
                                    {/* Tab connecting line to navbar bottom */}
                                    <div className="absolute -bottom-1 left-0 right-0 h-1 bg-blue-600 rounded-t-sm"></div>
                                </div>
                            )}
                        </div>
                    }
                    {/* language & signup */}
                    <div className="space-x-8 hidden md:flex items-center">

                        {/* nav items */}
                        <ul className="md:flex text-base space-x-16 hidden">
                            {
                                navItems.slice(0, 1).map(({ link, path }) => {
                                    let isDisabled = !allowedMenuList.some(allowedMenu => allowedMenu.toLowerCase() === link.toLowerCase());
                                    const isActive = location.pathname === path;
                                    
                                    return (
                                        <Link 
                                            key={link} 
                                            to={path} 
                                            className={`block cursor-pointer text-base uppercase relative transition-all duration-200 ${
                                                isDisabled 
                                                ? 'cursor-not-allowed text-gray-400' 
                                                : isActive
                                                ? "text-blue-600 font-semibold pb-1 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-blue-600"
                                                : "hover:text-gray-400"
                                            }`}
                                        >
                                            {link}
                                            {isActive && !isDisabled && (
                                                <span className="absolute -top-1 -right-2 w-2 h-2 bg-blue-600 rounded-full"></span>
                                            )}
                                        </Link>
                                    );
                                })
                            }


                            {name && (
                                <>
                                    {isMenuAllowed('dashboard', allowedMenuList) ? (
                                        <Link 
                                            to="/dashboard" 
                                            className={`block cursor-pointer text-base uppercase relative transition-all duration-200 ${
                                                location.pathname === '/dashboard'
                                                ? "text-blue-600 font-semibold pb-1 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-blue-600"
                                                : "hover:text-gray-400"
                                            }`}
                                        >
                                            Dashboard
                                            {location.pathname === '/dashboard' && (
                                                <span className="absolute -top-1 -right-2 w-2 h-2 bg-blue-600 rounded-full"></span>
                                            )}
                                        </Link>
                                    ) : (
                                        <span className="block text-gray-400 cursor-not-allowed uppercase">
                                            Dashboard
                                        </span>
                                    )}
                                </>
                            )}
                        </ul>
                        <>
                            {name &&
                                <>
                                    {isMenuAllowed('backoffice', allowedMenuList) ? (
                                        <div className="relative">
                                            <span 
                                                onClick={toggleMasterMenu} 
                                                className={`block cursor-pointer text-base uppercase relative transition-all duration-200 ${
                                                    activeParentMenu === 'backoffice'
                                                    ? "text-blue-600 font-semibold pb-1 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-blue-600"
                                                    : "hover:text-gray-400"
                                                }`}
                                            >
                                                Backoffice
                                                {activeParentMenu === 'backoffice' && (
                                                    <span className="absolute -top-1 -right-2 w-2 h-2 bg-blue-600 rounded-full"></span>
                                                )}
                                            </span>

                                            <div ref={reportRef} className={`w-[280px] text-sm space-y-2 px-4 mt-12 pb-5 bg-white shadow-2xl border border-gray-200 rounded-lg ${isMasterOpen ? "block absolute top-0 right-10 z-50" : "hidden"}`}>

                                                <IoTriangleSharp className="right-4 -top-2 text-white absolute drop-shadow-md" />
                                                
                                                <div className="pt-3">
                                                    <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3 px-2">
                                                        Backoffice Functions
                                                    </div>
                                                    {backOfficeLinks.map((link, index) => {
                                                        const isDisabled = !allowedMenuList.some(allowedMenuList => allowedMenuList.toLowerCase() === link.label.toLowerCase());
                                                        const isCurrentPage = activeSubMenu === link.label;
                                                        
                                                        return (
                                                            <React.Fragment key={link.label}>
                                                                <Link
                                                                    onClick={isDisabled ? (e) => e.preventDefault() : closeMenu}
                                                                    to={link.route}
                                                                    className={`flex items-center py-2 px-3 rounded-md transition-all duration-200 ${
                                                                        isDisabled 
                                                                        ? 'text-gray-400 cursor-not-allowed' 
                                                                        : isCurrentPage
                                                                        ? 'text-blue-700 bg-blue-100 border-l-4 border-blue-600 font-semibold shadow-sm'
                                                                        : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50 hover:border-l-4 hover:border-blue-300'
                                                                    } uppercase`}
                                                                >
                                                                    <span className="flex items-center w-full">
                                                                        {link.icon}
                                                                        <span className="flex-1">{link.label}</span>
                                                                        {isCurrentPage && (
                                                                            <span className="ml-2 w-2 h-2 bg-blue-600 rounded-full"></span>
                                                                        )}
                                                                    </span>
                                                                </Link>
                                                                {(index === 5 || index === 9 || index === 12) && <hr className="my-2 border-gray-200" />}
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <span className="block text-gray-400 cursor-not-allowed uppercase">
                                            Backoffice
                                        </span>
                                    )}
                                </>
                            }
                        </>

                        {name &&
                            <>
                                {isMenuAllowed('report', allowedMenuList) ? (
                                    <div className="relative">
                                        <span 
                                            onClick={toggleReportMenu} 
                                            className={`block cursor-pointer text-base uppercase relative transition-all duration-200 ${
                                                activeParentMenu === 'report'
                                                ? "text-blue-600 font-semibold pb-1 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-blue-600"
                                                : "hover:text-gray-400"
                                            }`}
                                        >
                                            Report
                                            {activeParentMenu === 'report' && (
                                                <span className="absolute -top-1 -right-2 w-2 h-2 bg-blue-600 rounded-full"></span>
                                            )}
                                        </span>

                                        <div ref={adminRef} className={`w-[220px] text-sm space-y-2 px-4 mt-12 pb-5 bg-white shadow-2xl border border-gray-200 rounded-lg ${isReportOpen ? "block absolute top-0 right-10 z-50" : "hidden"}`}>

                                            <IoTriangleSharp className="right-4 -top-2 text-white absolute drop-shadow-md" />
                                            
                                            <div className="pt-3">
                                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3 px-2">
                                                    Reports & Analytics
                                                </div>
                                                {reportsLinks.map((link, index) => {
                                                    const isDisabled = !allowedMenuList.some(allowedMenuList => allowedMenuList.toLowerCase() === link.name.toLowerCase());
                                                    const isCurrentPage = activeSubMenu === link.name;
                                                    
                                                    return (
                                                        <React.Fragment key={link.name}>
                                                            <Link
                                                                onClick={isDisabled ? (e) => e.preventDefault() : closeMenu}
                                                                to={link.route}
                                                                className={`flex items-center py-2 px-3 rounded-md transition-all duration-200 ${
                                                                    isDisabled 
                                                                    ? 'text-gray-400 cursor-not-allowed' 
                                                                    : isCurrentPage
                                                                    ? 'text-blue-700 bg-blue-100 border-l-4 border-blue-600 font-semibold shadow-sm'
                                                                    : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50 hover:border-l-4 hover:border-blue-300'
                                                                } uppercase`}
                                                            >
                                                                <span className="flex items-center w-full">
                                                                    {link.icon}
                                                                    <span className="flex-1">{link.name}</span>
                                                                    {isCurrentPage && (
                                                                        <span className="ml-2 w-2 h-2 bg-blue-600 rounded-full"></span>
                                                                    )}
                                                                </span>
                                                            </Link>
                                                            {(index === 2 || index === 3 || index === 4 || index === 6) && <hr className="my-2 border-gray-200" />}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <span className="block text-gray-400 cursor-not-allowed uppercase">
                                        Report
                                    </span>
                                )}
                            </>
                        }

                        {name &&
                            <>
                                {isMenuAllowed('admin', allowedMenuList) ? (
                                    <div className="relative">
                                        <span 
                                            onClick={toggleAdminMenu} 
                                            className={`block cursor-pointer text-base uppercase relative transition-all duration-200 ${
                                                activeParentMenu === 'admin'
                                                ? "text-blue-600 font-semibold pb-1 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-blue-600"
                                                : "hover:text-gray-400"
                                            }`}
                                        >
                                            Admin
                                            {activeParentMenu === 'admin' && (
                                                <span className="absolute -top-1 -right-2 w-2 h-2 bg-blue-600 rounded-full"></span>
                                            )}
                                        </span>

                                        <div ref={adminRef} className={`w-[250px] text-sm space-y-2 px-4 mt-12 pb-5 bg-white shadow-2xl border border-gray-200 rounded-lg ${isAdminOpen ? "block absolute top-0 right-10 z-50" : "hidden"}`}>

                                            <IoTriangleSharp className="right-4 -top-2 text-white absolute drop-shadow-md" />
                                            
                                            <div className="pt-3">
                                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3 px-2">
                                                    Administration
                                                </div>
                                                {adminLinks.map((link, index) => {
                                                    const isDisabled = !allowedMenuList.some(allowedMenuList => allowedMenuList.toLowerCase() === link.label.toLowerCase());
                                                    const isCurrentPage = activeSubMenu === link.label;
                                                    
                                                    return (
                                                        <React.Fragment key={link.label}>
                                                            <Link
                                                                onClick={isDisabled ? (e) => e.preventDefault() : closeMenu}
                                                                to={link.route}
                                                                className={`flex items-center py-2 px-3 rounded-md transition-all duration-200 ${
                                                                    isDisabled 
                                                                    ? 'text-gray-400 cursor-not-allowed' 
                                                                    : isCurrentPage
                                                                    ? 'text-blue-700 bg-blue-100 border-l-4 border-blue-600 font-semibold shadow-sm'
                                                                    : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50 hover:border-l-4 hover:border-blue-300'
                                                                } uppercase`}
                                                            >
                                                                <span className="flex items-center w-full">
                                                                    {link.icon}
                                                                    <span className="flex-1">{link.label}</span>
                                                                    {isCurrentPage && (
                                                                        <span className="ml-2 w-2 h-2 bg-blue-600 rounded-full"></span>
                                                                    )}
                                                                </span>
                                                            </Link>
                                                            {(index === 2 || index === 3 || index === 4 || index === 6) && <hr className="my-2 border-gray-200" />}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <span className="block text-gray-400 cursor-not-allowed uppercase">
                                        Admin
                                    </span>
                                )}
                            </>
                        }

                        {/* Bookmark */}
                        {/* <span className="hidden lg:flex pl-6 items-center hover:text-secondary cursor-pointer"><FaRegBookmark className="mr-2" /></span> */}

                        <NotificationBell isAuthenticated={Boolean(name)} />

                        <span className="ml-4 text-blue-400 text-sm uppercase">
                            {name && <>Welcome</>} {name} {name && <>@</>} {companyName} </span>
                        {/* user menu */}
                        {name === "" ?
                            <img onClick={toggleUserMenu} src={usernotsign} alt="" className="w-10 inline-block items-center rounded-full hover:shadow-md " />
                            :
                            <img onClick={toggleUserMenu} src={usersignin} alt="" className="w-10 inline-block items-center rounded-full hover:shadow-md " />
                        }
                        {/* <div className="relative"> */}
                        <div className={` w-[200px] text-sm space-y-4  px-4 mt-12 pb-5 bg-primary ${isUserMenuOpen ? "block absolute top-0 right-10 shadow-xl" : "hidden"}`}>

                            <IoTriangleSharp className="right-7 -top-2 text-primary absolute " />
                            {!name &&
                                <div>
                                    <span onClick={toggleLoginModal} className="flex items-center text-blue-300 hover:text-gray-300 cursor-pointer mb-2"><MdLogin className="mr-2 text-[16px] cursor-pointer uppercase" />LOGIN</span>
                                    <span onClick={toggleRegisterModal} className="flex items-center text-blue-300 hover:text-gray-300 cursor-pointer"><FiUserPlus className="mr-2 text-[16px] cursor-pointer uppercase" />REGISTER</span>
                                </div>
                            }
                            {name &&
                                <div>
                                    <Link to="/preferences" className="flex items-center text-blue-300 hover:text-gray-300  mb-2 cursor-pointer"><PiFunnelBold className="mr-2 text-[16px] cursor-pointer uppercase" />MY PREFERENCES</Link>
                                    <Link to="/profile" className="flex items-center text-blue-300 hover:text-gray-300  mb-2 cursor-pointer"><FaRegUser className="mr-2 cursor-pointer uppercase" />VIEW PROFILE</Link>
                                    <span onClick={logOut} className="flex items-center text-blue-300 hover:text-gray-300 cursor-pointer"><PiSignOutBold className="mr-2 text-[16px] cursor-pointer uppercase" />SIGN OUT</span>
                                </div>

                            }
                        </div>
                        {/* </div> */}
                    </div>

                    {/* menu btn. only display on mobile */}

                    <div className="md:hidden flex items-center gap-3">
                        <NotificationBell isAuthenticated={Boolean(name)} compact={true} />
                        <span className="text-blue-400  mr-6 ">{name}</span>
                        <button onClick={toggleMenu} className="text-white text-xl focus:outline-none
                     focus:text-gray-300">
                            {
                                isMenuOpen ? (<FaXmark className="w-6 h-6 text-primary " />) : (<FaBars className="w-6 h-6 text-primary" />)
                            }
                        </button>
                    </div>
                </div>

            </nav>

            {/* mobile view menu items */}
            <div ref={menuRef} className={`space-y-1 px-4 pt-16 pb-4 bg-primary overflow-y-auto max-h-screen ${isMenuOpen ? "block lg:hidden fixed top-0 right-0 left-0 z-50" : "hidden"}`}>

                {
                    navItems.slice(0, 1).map(({ link, path }) => {
                        const isDisabled = !allowedMenuList.some(allowedMenu => allowedMenu.toLowerCase() === link.toLowerCase());
                        return (
                            <Link 
                                key={link} 
                                to={path} 
                                onClick={isDisabled ? (e) => e.preventDefault() : () => { closeMobileMenu(); }}
                                className={`block mb-2 uppercase ${isDisabled ? 'text-gray-500 cursor-not-allowed' : 'text-blue-300 hover:text-gray-300'}`}
                            >
                                {link}
                            </Link>
                        );
                    })
                }
                {!name &&
                    <div>
                        <span onClick={toggleLoginModal} className="z-100 flex items-center mb-2 text-blue-300 hover:text-gray-300 cursor-pointer uppercase"><MdLogin className="mr-2 text-[16px] cursor-pointer" />Login</span>
                        <span onClick={toggleRegisterModal} className="flex items-center text-blue-300 hover:text-gray-300 cursor-pointer uppercase"><FiUserPlus className="mr-2 text-[16px] cursor-pointer" />Register</span>
                    </div>
                }
                {name &&
                    <div>
                        {/* Dashboard Link */}
                        {isMenuAllowed('dashboard', allowedMenuList) ? (
                            <Link to="/dashboard" onClick={() => { closeMobileMenu(); }} className="flex items-center text-blue-300 hover:text-gray-300 mb-2 cursor-pointer uppercase">
                                <MdDisplaySettings className="mr-2 text-[16px] cursor-pointer" />Dashboard
                            </Link>
                        ) : (
                            <span className="flex items-center text-gray-500 cursor-not-allowed mb-2 uppercase">
                                <MdDisplaySettings className="mr-2 text-[16px]" />Dashboard
                            </span>
                        )}

                        {/* BackOffice Menu */}
                        {isMenuAllowed('backoffice', allowedMenuList) ? (
                            <div className="mb-3">
                                <div className="flex items-center text-blue-300 mb-2 font-semibold uppercase">
                                    <span className="flex items-center">
                                        <FiEdit className="mr-2 text-[16px]" />BackOffice
                                    </span>
                                </div>
                                <div className="ml-6 space-y-1 border-l-2 border-blue-400 pl-3">
                                    {backOfficeLinks.map((link) => {
                                        const isDisabled = !allowedMenuList.some(allowedMenu => allowedMenu.toLowerCase() === link.label.toLowerCase());
                                        return (
                                            <Link
                                                key={link.label}
                                                to={link.route}
                                                onClick={isDisabled ? (e) => e.preventDefault() : () => { closeMobileMenu(); }}
                                                className={`flex items-center py-1 text-sm ${
                                                    isDisabled 
                                                    ? 'text-gray-500 cursor-not-allowed' 
                                                    : 'text-blue-200 hover:text-white'
                                                } uppercase`}
                                            >
                                                {link.icon}
                                                {link.label}
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : (
                            <span className="flex items-center text-gray-500 cursor-not-allowed mb-2 uppercase">
                                <FiEdit className="mr-2 text-[16px]" />BackOffice
                            </span>
                        )}

                        {/* Report Menu */}
                        {isMenuAllowed('report', allowedMenuList) ? (
                            <div className="mb-3">
                                <div className="flex items-center text-blue-300 mb-2 font-semibold uppercase">
                                    <span className="flex items-center">
                                        <IoPrintOutline className="mr-2 text-[16px]" />Report
                                    </span>
                                </div>
                                <div className="ml-6 space-y-1 border-l-2 border-blue-400 pl-3">
                                    {reportsLinks.map((link) => {
                                        const isDisabled = !allowedMenuList.some(allowedMenu => allowedMenu.toLowerCase() === link.name.toLowerCase());
                                        return (
                                            <Link
                                                key={link.name}
                                                to={link.route}
                                                onClick={isDisabled ? (e) => e.preventDefault() : () => { closeMobileMenu(); }}
                                                className={`flex items-center py-1 text-sm ${
                                                    isDisabled 
                                                    ? 'text-gray-500 cursor-not-allowed' 
                                                    : 'text-blue-200 hover:text-white'
                                                } uppercase`}
                                            >
                                                {link.icon}
                                                {link.name}
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : (
                            <span className="flex items-center text-gray-500 cursor-not-allowed mb-2 uppercase">
                                <IoPrintOutline className="mr-2 text-[16px]" />Report
                            </span>
                        )}

                        {/* Admin Menu */}
                        {isMenuAllowed('admin', allowedMenuList) ? (
                            <div className="mb-3">
                                <div className="flex items-center text-blue-300 mb-2 font-semibold uppercase">
                                    <span className="flex items-center">
                                        <MdDisplaySettings className="mr-2 text-[16px]" />Admin
                                    </span>
                                </div>
                                <div className="ml-6 space-y-1 border-l-2 border-blue-400 pl-3">
                                    {adminLinks.map((link) => {
                                        const isDisabled = !allowedMenuList.some(allowedMenu => allowedMenu.toLowerCase() === link.label.toLowerCase());
                                        return (
                                            <Link
                                                key={link.label}
                                                to={link.route}
                                                onClick={isDisabled ? (e) => e.preventDefault() : () => { closeMobileMenu(); }}
                                                className={`flex items-center py-1 text-sm ${
                                                    isDisabled 
                                                    ? 'text-gray-500 cursor-not-allowed' 
                                                    : 'text-blue-200 hover:text-white'
                                                } uppercase`}
                                            >
                                                {link.icon}
                                                {link.label}
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : (
                            <span className="flex items-center text-gray-500 cursor-not-allowed mb-2 uppercase">
                                <MdDisplaySettings className="mr-2 text-[16px]" />Admin
                            </span>
                        )}

                        {/* User Profile Links */}
                        <hr className="my-3 border-blue-400" />
                        <Link to="/preferences" onClick={() => { closeMobileMenu(); }} className="flex items-center text-blue-300 hover:text-gray-300 mb-2 cursor-pointer uppercase">
                            <PiFunnelBold className="mr-2 text-[16px] cursor-pointer" />My Preferences
                        </Link>
                        <Link to="/profile" onClick={() => { closeMobileMenu(); }} className="flex items-center text-blue-300 hover:text-gray-300 mb-2 cursor-pointer uppercase">
                            <FaRegUser className="mr-2 cursor-pointer" />View Profile
                        </Link>
                        <span onClick={logOut} className="flex items-center text-blue-300 hover:text-gray-300 cursor-pointer uppercase">
                            <PiSignOutBold className="mr-2 text-[16px] cursor-pointer" />Sign Out
                        </span>
                    </div>
                }
            </div>


            {/*
                <button onClick={toggleLoginModal} data-modal-target="authentication-modal" data-modal-toggle="authentication-modal" className="block mt-20 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" type="button">
                    Toggle modal
                </button>
            */}


            {/* Login Model */}
            {loginModel &&

                <Login toggleLoginModal={toggleLoginModal} toggleRegisterModal={toggleRegisterModal} toggleLostPasswordModal={toggleLostPasswordModal} />

            }

            {/* Register Model */}
            {registerModel &&

                <Register toggleRegisterModal={toggleRegisterModal} toggleLoginModal={toggleLoginModal} />

            }

            {/* Register Model */}
            {lostpasswordModel &&

                <LostPassword toggleRegisterModal={toggleRegisterModal} toggleLoginModal={toggleLoginModal} toggleLostPasswordModal={toggleLostPasswordModal} />

            }
        </>
    )
}

export default Navbar